import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import Typography from "@material-ui/core/Typography";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Paper from "@material-ui/core/Paper";
import { TextField, withStyles } from "@material-ui/core";
import classNames from "classnames";
import AutoComplete from "./AutoComplete";
import API from "../../api";
import styles from "./CustomTextField/styles";
import CustomTextField from "./CustomTextField";

const ClientAutoComplete = ({ onNoOptionClick, id, ...props }) => {
  const loadOptions = useCallback(async name => {
    const res = await API.factoring.getFactoringClients(
      "approved,declined,dead",
      "",
      20,
      0,
      {
        company_profile__name: name
      }
    );
    if (!isEmpty(res.results)) {
      return map(res.results, object => ({
        label: object.company_profile.name,
        ...object
      }));
    }
    return [];
  }, []);

  const inputComponent = ({ inputRef, ...props }) => {
    return <div ref={inputRef} {...props} />;
  };

  const Control = withStyles(styles)(
    ({ classes, selectProps, innerRef, children, innerProps }) => {
      const {
        textFieldProps: { withStyle }
      } = selectProps;
      const underlineClasses = classNames({
        [classes.underlineAddress]: true
      });
      const inputClasses = withStyle
        ? {
            classes: {
              underline: underlineClasses,
              input: classes.input,
              error: classes.errorInput
            }
          }
        : {};
      const labelClasses = withStyle
        ? {
            classes: {
              focused: classes.cssFocused,
              error: classes.errorLabel
            }
          }
        : {};
      return (
        <CustomTextField
          fullWidth
          error={selectProps.error}
          InputProps={{
            inputComponent,
            id,
            ...inputClasses,
            inputProps: {
              className: selectProps.classes.input,
              inputRef: innerRef,
              children,
              ...innerProps
            }
          }}
          {...selectProps.textFieldProps}
          InputLabelProps={{
            ...labelClasses,
            shrink: true
          }}
        />
      );
    }
  );

  const Option = ({
    innerRef,
    isFocused,
    isSelected,
    innerProps,
    children,
    data,
    ...props
  }) => (
    <ListItem dense divider selected={isFocused} button buttonRef={innerRef}>
      <ListItemText
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400
        }}
        {...innerProps}
        primary={data.company_name}
        secondary={
          <React.Fragment>
            <Typography component="span" color="textSecondary">
              {`${data.owner_profile.name_first} ${data.owner_profile.name_last}`}
            </Typography>
            <Typography component="span" color="textSecondary">
              {`${data.company_profile.name}`}
            </Typography>
            {data.company_profile.mc && `MC: ${data.company_profile.mc}\n`}
            {data.company_profile.dot && `DOT: ${data.company_profile.dot}\n`}
            {data.company_profile.id && `DOT: ${data.company_profile.id}`}
          </React.Fragment>
        }
      />
    </ListItem>
  );

  const Menu = ({ selectProps, innerProps, children }) => (
    <Paper square className={selectProps.classes.paper} {...innerProps}>
      <List dense="dense">{children}</List>
    </Paper>
  );

  return (
    <AutoComplete
      loadOptions={name => loadOptions(name)}
      autoCompleteComponents={{ Option, Menu, Control }}
      {...props}
    />
  );
};
export default ClientAutoComplete;
